import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AnonymousReportState } from './anonymous-report.reducer';
import { compareConsolidation } from 'src/app/modules/audits/utils/report.utils';
import { selectMergedRouteParams } from '../router/selectors';
import { calculateCheckProductionTimes, isSubwayCustomer } from 'src/app/modules/admin/utils/subway.utils';
import dayjs from 'dayjs';
import { WaitTimesComposition } from '../../modules/report-components/models/PeopleCounter';

export const selectReport = createFeatureSelector<AnonymousReportState>('anonymousReport');

export const selectCurrentReport = createSelector(selectReport, state => state.report);

export const selectAnonymousUser = createSelector(selectReport, state => state.user);

export const selectConsolidationComparison = createSelector(selectReport, ({ report }) =>
  report && report.trends && report.trends.length >= 2
    ? compareConsolidation(report.consolidation, report.trends[report.trends.length - 2].consolidation)
    : null,
);

export const selectAnonymousToken = createSelector(selectMergedRouteParams, params =>
  params && 'token' in params ? (params.token as string) : null,
);

export const selectIsSubwayCustomer = createSelector(selectReport, state =>
  state.report ? isSubwayCustomer(state.report.customerId, state.report.locationId) : false,
);

export const selectProductionStats = createSelector(selectReport, state => (state.report ? state.report.productionStats : null));

export const selectUpsellMatrix = createSelector(selectReport, state => (state.report ? state.report.upsellStats : null));

export const selectWaitTimesComposition = createSelector(selectCurrentReport, selectIsSubwayCustomer, (state, isQsr) => {
  if (!state || !state.peopleCountStats || !isQsr) return [];
  let productionTimes = calculateCheckProductionTimes(state);

  let exitTimes = state.peopleCountStats.waitTimes
    .filter(x => x.boughtSomething)
    .map(w => ({
      leftAt: dayjs(w.entered).add(w.waitedFor, 's'),
      ...w,
    }));
  let res = [] as WaitTimesComposition[];

  for (let exitTime of exitTimes) {
    let indexOfCheck = productionTimes.findIndex(x => x.date.diff(exitTime.leftAt, 's') < 60);
    let productionTime = productionTimes[indexOfCheck];
    if (!productionTime) {
      continue;
    }
    res.push({
      leftAt: exitTime.leftAt,
      productionTimes: productionTime.pt,
      waitedFor: exitTime.waitedFor,
      id: exitTime.id,
    });

    productionTimes = [...productionTimes.filter((_, i) => i !== indexOfCheck)];
  }
  return res;
});
